"use strict";

require("core-js/modules/es.date.to-string.js");
function _interopRequireDefault(o) {
  return o && o.__esModule ? o : {
    "default": o
  };
}
function _objectWithoutProperties(o, e) {
  var r = {};
  for (var t in o) e.indexOf(t) >= 0 || Object.prototype.hasOwnProperty.call(o, t) && (r[t] = o[t]);
  return r;
}
function make(o, e) {
  var r = e.distance,
    t = e.left,
    p = e.right,
    a = e.up,
    l = e.down,
    i = e.top,
    u = e.bottom,
    n = e.big,
    s = e.mirror,
    d = e.opposite,
    _ = (r ? r.toString() : 0) + ((t ? 1 : 0) | (p ? 2 : 0) | (i || l ? 4 : 0) | (u || a ? 8 : 0) | (s ? 16 : 0) | (d ? 32 : 0) | (o ? 64 : 0) | (n ? 128 : 0));
  if (lookup.hasOwnProperty(_)) return lookup[_];
  var f = t || p || a || l || i || u,
    y = void 0,
    b = void 0;
  if (f) {
    if (!s != !(o && d)) {
      var v = [p, t, u, i, l, a];
      t = v[0], p = v[1], i = v[2], u = v[3], a = v[4], l = v[5];
    }
    var c = r || (n ? "2000px" : "100%");
    y = t ? "-" + c : p ? c : "0", b = l || i ? "-" + c : a || u ? c : "0";
  }
  return lookup[_] = (0, _globals.animation)((o ? "to" : "from") + " {opacity: 0;" + (f ? " transform: translate3d(" + y + ", " + b + ", 0);" : "") + "}\n     " + (o ? "from" : "to") + " {opacity: 1;transform: none;} "), lookup[_];
}
function Fade() {
  var o = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : _globals.defaults,
    e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
    r = o.children,
    t = (o.out, o.forever),
    p = o.timeout,
    a = o.duration,
    l = void 0 === a ? _globals.defaults.duration : a,
    i = o.delay,
    u = void 0 === i ? _globals.defaults.delay : i,
    n = o.count,
    s = void 0 === n ? _globals.defaults.count : n,
    d = _objectWithoutProperties(o, ["children", "out", "forever", "timeout", "duration", "delay", "count"]),
    _ = {
      make: make,
      duration: void 0 === p ? l : p,
      delay: u,
      forever: t,
      count: s,
      style: {
        animationFillMode: "both"
      },
      reverse: d.left
    };
  return e ? (0, _wrap2["default"])(d, _, _, r) : _;
}
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var _propTypes = require("prop-types"),
  _globals = require("./globals"),
  _wrap = require("./wrap"),
  _wrap2 = _interopRequireDefault(_wrap),
  propTypes = {
    out: _propTypes.bool,
    left: _propTypes.bool,
    right: _propTypes.bool,
    top: _propTypes.bool,
    bottom: _propTypes.bool,
    big: _propTypes.bool,
    mirror: _propTypes.bool,
    opposite: _propTypes.bool,
    duration: _propTypes.number,
    timeout: _propTypes.number,
    distance: _propTypes.string,
    delay: _propTypes.number,
    count: _propTypes.number,
    forever: _propTypes.bool
  },
  lookup = {};
Fade.propTypes = propTypes, exports["default"] = Fade, module.exports = exports["default"];